import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/tarjeta-nfc")({
  beforeLoad: () => {
    throw redirect({ href: "/tarjeta-nfc-qr", statusCode: 301 });
  },
});
